import styled from 'styled-components'
import { textWeight, textSize } from 'lib/Text'

export const PopoverOptionButton = styled.button<{ active?: boolean }>`
  ${textWeight('semi')}
  ${textSize('pxs')}
  appearance: none;
  background: ${(props) => (props.active ? 'var(--black-10)' : 'transparent')};
  border-radius: var(--input-radius);
  color: var(--black-80);
  display: block;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  padding: 5px 8px;
  margin-bottom: 4px;

  &:disabled {
    color: var(--black-40);
    cursor: not-allowed;
  }

  &:hover {
    background: var(--black-10);
  }

  &:last-child {
    margin-bottom: 0;
  }
`

export const ClearPopoverOptionsButton = styled(PopoverOptionButton)`
  ${textWeight('regular')}
  background: var(--black-10);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;

  &:before {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.9 8.586L5.656 4.343 4.243 5.757 8.485 10l-4.242 4.243 1.414 1.414 4.242-4.243 4.243 4.243 1.414-1.414L11.314 10l4.242-4.243-1.414-1.414L9.9 8.586z' fill='%23000'/%3E%3C/svg%3E");
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-right: 4px;
  }
`

export const PopoverOptionLink = styled(PopoverOptionButton).attrs({ as: 'a' })`
  text-decoration: none;
`
